export const FileArrowUpIcon = ({ className = '', style = {}, ...props }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 384 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ verticalAlign: 'middle', ...style }}
      {...props}
    >
      <defs>
        <linearGradient id="sparkle-gradient" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#2368F6" />
          <stop offset="100%" stopColor="#A717CB" />
        </linearGradient>
      </defs>
      <path
        fill="url(#sparkle-gradient)"
        d="M48 448L48 64c0-8.8 7.2-16 16-16l160 0 0 80c0 17.7 14.3 32 32 32l80 0 0 288c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM64 0C28.7 0 0 28.7 0 64L0 448c0 35.3 28.7 64 64 64l256 0c35.3 0 64-28.7 64-64l0-293.5c0-17-6.7-33.3-18.7-45.3L274.7 18.7C262.7 6.7 246.5 0 229.5 0L64 0zM216 408l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31L168 408c0 13.3 10.7 24 24 24s24-10.7 24-24z"
      />
    </svg>
  );
};
